import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Widget, MasterDetailForm, Button, FormSubmitButton } from '@digital/ui';
import { uploadLinhaFile } from '@app/api/controleQaqc';
import { UploadFile } from '@app/components';

export interface Props {
  linhaId: string;
  arquivoId: string;
  onUpdate: any;
  hasFile?: boolean;
}

const UploadLinhaFile = (props: Props) => {
  const { linhaId, arquivoId, onUpdate, hasFile } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [fileArquivo, setfileArquivo] = useState<boolean>(false);

  const handleUploadLinhaFile = (values: any) => {
    var form = new FormData();
    form.append('file', values['file']);
    form.append('linhaId', linhaId);
    if (arquivoId) form.append('arquivoId', arquivoId);
    uploadLinhaFile(form).then(data => {
      if (data) {
        setfileArquivo(true);
        setfileArquivo(false);
        setShowModal(false);
        onUpdate();
      }
    });
  };

  return (
    <>
      <Tooltip title={hasFile ? `Substituir Arquivo` : `Adicionar Arquivo`}>
        <Button
          id={'btnNovaPlanilha'}
          type="link"
          icon="ui-upload"
          onClick={() => {
            setShowModal(true);
          }}
        />
      </Tooltip>
      <Modal
        visible={showModal}
        width={620}
        title="Importar Anexo"
        onCancel={() => {
          setShowModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          onSubmit={data => handleUploadLinhaFile(data)}
          actions={[
            <Button
              type='link'
              style={{marginLeft: '5px'}}
              onClick={() => {
                setfileArquivo(false);
                setShowModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton noIcon={true} title="Enviar" type="primary" />,
          ]}>
          <Widget>
            <UploadFile
              nameFormData={'file'}
              label={'Adicionar Arquivo'}
              hasFile={fileArquivo}
              limparCampo={showModal}
              idDoComponente={'file'}
            />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};

export default UploadLinhaFile;
